import { render, staticRenderFns } from "./document_extraction_zone.vue?vue&type=template&id=47b5ad32"
import script from "./document_extraction_zone.vue?vue&type=script&lang=js"
export * from "./document_extraction_zone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports